import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function SettingsLayout({ title, subtitle, children, testId }) {
  const navigate = useNavigate();
  const returnTo = useLocation().state?.returnTo;
  return (
    <div data-testid={testId} className="debii-shell min-h-screen px-5 py-4 pb-10">
      <div className="flex items-center gap-3">
        <button
          data-testid="settings-back"
          onClick={() => (returnTo ? navigate(-1) : navigate("/profile"))}
          className="h-10 w-10 rounded-full bg-secondary flex items-center justify-center shrink-0"
          aria-label="Back to profile"
        >
          <ArrowLeft className="h-5 w-5 text-primary" />
        </button>
        <div className="min-w-0">
          <h1 className="font-display text-xl font-bold text-foreground truncate">{title}</h1>
          {subtitle && <p className="text-xs text-muted-foreground truncate">{subtitle}</p>}
        </div>
      </div>
      <div className="mt-6">{children}</div>
    </div>
  );
}
